import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const childrenReturnsIntakePageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessPageBreadcrumbs(navigate),
  { label: 'Rendiciones', onClick: () => navigate('/business/returns-intake') },
];

export const childrenReturnsIntakePageSummariesBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Rendiciones', to: '/business/returns-intake' },
  { label: 'Escaneo', to: '/business/returns-intake/scanner' },
];

export const childrenReturnsIntakeReportBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Rendiciones', to: '/business/returns-intake' },
];

export const childrenReturnsIntakeOpenReturnsBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Rendiciones', to: '/business/returns-intake' },
];

export const childrenReturnsIntakePendingShippingsBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Rendiciones', to: '/business/returns-intake' },
];

export const childrenReturnsIntakeNotReportedShippingsBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Rendiciones', to: '/business/returns-intake' },
];
